import { useMapUserQuery, useUnMapUserQuery } from '@/hook';
import { Close, VButton, VDialog, VFlex, VSelect, VStack } from '@/package';
import type { User, UserGroup } from '@/type';

export const UserProfileChangeGroupModal = ({
  groupList,
  selectedUser,
  visible,
  setVisible,
  userGroup,
  setUserGroup,
}: {
  groupList: UserGroup[];
  selectedUser: User;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  userGroup: UserGroup[];
  setUserGroup: (userGroup: UserGroup[]) => void;
}) => {
  const { mutateAsync: mapUser } = useMapUserQuery();
  const { mutateAsync: unMapUser } = useUnMapUserQuery();

  return (
    <VDialog
      visible={visible}
      onUpdateVisible={setVisible}
      dialogMainClass="w-[328px] px-4 bg-white"
    >
      <VStack className="h-full w-full">
        <VFlex justify="between" items="center" className="w-full py-2">
          <div className="text-body-xl">Change group</div>
          <Close
            role="button"
            className="h-6 w-6 text-gray-400"
            onClick={() => setVisible(false)}
          />
        </VFlex>

        <VFlex justify="center" items="center" className="w-full py-4">
          <VSelect
            multiple
            itemList={groupList.map(group => ({
              value: group.id,
              label: group.name,
            }))}
            value={userGroup.map(g => g.id as unknown as string)}
            onChange={e => {
              const tempUserGroupIdList = e.target.value as number[];
              const nextGroupList = groupList.filter(g =>
                tempUserGroupIdList.includes(g.id),
              );
              setUserGroup(nextGroupList);
            }}
          />
        </VFlex>

        <VFlex
          justify="end"
          items="center"
          className="w-full pt-2 pb-4"
          gap={0.25}
        >
          <VButton
            outlined
            size="sm"
            variant="secondary"
            onClick={() => setVisible(false)}
          >
            Cancel
          </VButton>
          <VButton
            size="sm"
            onClick={async () => {
              const toUnMapGroup =
                groupList?.filter(
                  g =>
                    g.users.find(u => u.id === selectedUser?.id) &&
                    !userGroup.find(gr => gr.id === g.id),
                ) ?? [];
              const toMapGroup =
                groupList?.filter(
                  g =>
                    !g.users.find(u => u.id === selectedUser?.id) &&
                    userGroup.find(gr => gr.id === g.id),
                ) ?? [];

              await Promise.allSettled([
                ...toMapGroup.map(g =>
                  mapUser({
                    userGroup: g,
                    users: [selectedUser!],
                  }),
                ),
                ...toUnMapGroup.map(g =>
                  unMapUser({
                    userGroup: g,
                    users: [selectedUser!],
                  }),
                ),
              ]);
              setVisible(false);
            }}
          >
            Ok
          </VButton>
        </VFlex>
      </VStack>
    </VDialog>
  );
};
